var blzEvent = require('../../app/services/tracking/blz-event');

(function () {
  try {
    const scrollTracker = {
      '10': 0,
      '25': 0,
      '50': 0,
      '75': 0,
      '100': 0
    };

    $(window).on('scroll', function () {
      var currentPosition = $(document).scrollTop();
      var windowViewingArea = $(window).height();
      var documentHeight = $(document).height();

      var trackLength = documentHeight - windowViewingArea;
      var percentScrolled = Math.round((currentPosition / trackLength) * 100);

      var fireEvent = 0;
      var scrollBucket = 0;

      if (percentScrolled >= 10 && percentScrolled < 25) {
        if (scrollTracker['10'] == 0) {
          fireEvent = 1;
          scrollTracker['10'] = 1;
          scrollBucket = '10';
        }
      } else if (percentScrolled >= 25 && percentScrolled < 50) {
        if (scrollTracker['25'] == 0) {
          fireEvent = 1;
          scrollTracker['25'] = 1;
          scrollBucket = '25';
        }
      } else if (percentScrolled >= 50 && percentScrolled < 75) {
        if (scrollTracker['50'] == 0) {
          fireEvent = 1;
          scrollTracker['50'] = 1;
          scrollBucket = '50';
        }
      } else if (percentScrolled >= 75 && percentScrolled < 100) {
        if (scrollTracker['75'] == 0) {
          fireEvent = 1;
          scrollTracker['75'] = 1;
          scrollBucket = '75';
        }
      } else if (percentScrolled == 100) {
        if (scrollTracker['100'] == 0) {
          fireEvent = 1;
          scrollTracker['100'] = 1;
          scrollBucket = '100';
        }
      }
      if (fireEvent != 0) {
        blzEvent.interaction(
          {},
          {
            category: (blz.pageName || '').toUpperCase(),
            action: 'Scroll',
            label: 'Scroll-Navigation',
            values: 'User-Scroll-Percentual;' + scrollBucket
          }
        );
      }
      blz.scrollPercent = percentScrolled;
    });
  } catch (o_O) {
    //
  }
})();
